// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terminal-marking-page {
  min-height: 100vh;
  background: #f5f7fb;
  color: #222a3c;
}

.terminal-marking-content {
  width: min(980px, 100% - 32px);
  margin: 0 auto;
  padding: 28px 0 48px;
}

.terminal-marking-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 22px;
}
.terminal-marking-header h1 {
  margin: 0 0 5px;
  font-size: clamp(1.55rem, 4vw, 2.2rem);
}
.terminal-marking-header p {
  margin: 0;
  color: #6f7890;
}
.terminal-marking-header .terminal-marking-company {
  margin-top: 8px;
  color: #222a3c;
  font-weight: 700;
}
.terminal-marking-header button {
  flex: 0 0 auto;
}

.terminal-marking-header button,
.terminal-marking-card button {
  min-height: 44px;
  border: 0;
  border-radius: 14px;
  padding: 12px 18px;
  background: #e72f44;
  color: #fff;
  font: inherit;
  font-size: 13px;
  font-weight: 750;
  cursor: pointer;
}
.terminal-marking-header button:disabled,
.terminal-marking-card button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.terminal-marking-message,
.terminal-marking-empty {
  padding: 16px 18px;
  margin-bottom: 16px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 5px 22px rgba(34, 42, 60, 0.07);
  line-height: 1.4;
}

.terminal-marking-message.warning {
  color: #674b00;
  background: #fff8dc;
  border: 1px solid #f3d77b;
}

.terminal-marking-message.error {
  color: #9e1d2d;
  background: #fff0f2;
  border: 1px solid #f1bbc3;
}

.terminal-marking-message.success {
  color: #166333;
  background: #eefaf2;
  border: 1px solid #b8e5c7;
}

.terminal-marking-list {
  display: grid;
  gap: 14px;
}

.terminal-marking-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 20px;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 6px 24px rgba(34, 42, 60, 0.08);
}

.terminal-marking-card-copy {
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-width: 0;
}
.terminal-marking-card-copy strong {
  font-size: 1.08rem;
  overflow-wrap: anywhere;
}
.terminal-marking-card-copy span {
  color: #6f7890;
  overflow-wrap: anywhere;
}

@media (max-width: 650px) {
  .terminal-marking-content {
    width: min(100% - 20px, 980px);
    padding-top: 18px;
  }
  .terminal-marking-header,
  .terminal-marking-card {
    align-items: stretch;
    flex-direction: column;
  }
  .terminal-marking-header button,
  .terminal-marking-card button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/TerminalMarkingPage/TerminalMarkingPage.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,8BAAA;EACA,cAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;EACA,sCAAA;AACJ;AAEE;EACE,SAAA;EACA,cAAA;AAAJ;AAGE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AADJ;AAIE;EACE,cAAA;AAFJ;;AAMA;;EAEE,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAHF;AAKE;;EACE,mBAAA;EACA,aAAA;AAFJ;;AAMA;;EAEE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6CAAA;EACA,gBAAA;AAHF;;AAMA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;AAHF;;AAMA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;AAHF;;AAMA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;AAHF;;AAMA;EACE,aAAA;EACA,SAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,6CAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAHF;AAKE;EACE,kBAAA;EACA,uBAAA;AAHJ;AAME;EACE,cAAA;EACA,uBAAA;AAJJ;;AAQA;EACE;IACE,8BAAA;IACA,iBAAA;EALF;EAQA;;IAEE,oBAAA;IACA,sBAAA;EANF;EASA;;IAEE,WAAA;EAPF;AACF","sourcesContent":[".terminal-marking-page {\n  min-height: 100vh;\n  background: #f5f7fb;\n  color: #222a3c;\n}\n\n.terminal-marking-content {\n  width: min(980px, calc(100% - 32px));\n  margin: 0 auto;\n  padding: 28px 0 48px;\n}\n\n.terminal-marking-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  margin-bottom: 22px;\n\n  h1 {\n    margin: 0 0 5px;\n    font-size: clamp(1.55rem, 4vw, 2.2rem);\n  }\n\n  p {\n    margin: 0;\n    color: #6f7890;\n  }\n\n  .terminal-marking-company {\n    margin-top: 8px;\n    color: #222a3c;\n    font-weight: 700;\n  }\n\n  button {\n    flex: 0 0 auto;\n  }\n}\n\n.terminal-marking-header button,\n.terminal-marking-card button {\n  min-height: 44px;\n  border: 0;\n  border-radius: 14px;\n  padding: 12px 18px;\n  background: #e72f44;\n  color: #fff;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 750;\n  cursor: pointer;\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: .45;\n  }\n}\n\n.terminal-marking-message,\n.terminal-marking-empty {\n  padding: 16px 18px;\n  margin-bottom: 16px;\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0 5px 22px rgba(34, 42, 60, .07);\n  line-height: 1.4;\n}\n\n.terminal-marking-message.warning {\n  color: #674b00;\n  background: #fff8dc;\n  border: 1px solid #f3d77b;\n}\n\n.terminal-marking-message.error {\n  color: #9e1d2d;\n  background: #fff0f2;\n  border: 1px solid #f1bbc3;\n}\n\n.terminal-marking-message.success {\n  color: #166333;\n  background: #eefaf2;\n  border: 1px solid #b8e5c7;\n}\n\n.terminal-marking-list {\n  display: grid;\n  gap: 14px;\n}\n\n.terminal-marking-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  padding: 20px;\n  border-radius: 18px;\n  background: #fff;\n  box-shadow: 0 6px 24px rgba(34, 42, 60, .08);\n}\n\n.terminal-marking-card-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  min-width: 0;\n\n  strong {\n    font-size: 1.08rem;\n    overflow-wrap: anywhere;\n  }\n\n  span {\n    color: #6f7890;\n    overflow-wrap: anywhere;\n  }\n}\n\n@media (max-width: 650px) {\n  .terminal-marking-content {\n    width: min(100% - 20px, 980px);\n    padding-top: 18px;\n  }\n\n  .terminal-marking-header,\n  .terminal-marking-card {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .terminal-marking-header button,\n  .terminal-marking-card button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
